import { RootState } from 'store';

export const userSessionSelector = (state: RootState) => state.user.session;
export const userTwilioTokenSelector = (state: RootState) => state.user.twilioToken;
export const userSelector = (state: RootState) => state.user;
